export default "__VITE_ASSET__CKd$2AsY__"